import { Config } from "../../configurations/config";
export const EmployeeLeaves_APIs = {
  getProjectTeamLeaves: `${Config.server_url}${Config.api_prefix}/Leave/GetProjectEmployeeLeaves?ProjectId=`,
  SendEmployeeLeaveDetailsToCustomer: `${Config.server_url}${Config.api_prefix}/Dashboard/SendEmployeeLeaveDetailsToCustomer`,
  teamWorkingStatus: `${Config.server_url}${Config.api_prefix}/Project/112/GetProjectEmployees`,
  progectDetails: `${Config.server_url}${Config.api_prefix}/Project`,
};
